import { Injectable, Injector } from '@angular/core';
import { BaseResourceService } from '../../models/services/base-resource.service';
import { TermoAcessoUsuarioAceite } from '../../entidade/comum/termo-acesso-usuario-aceite.model';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TermoAcessoUsuarioAceiteService extends BaseResourceService<TermoAcessoUsuarioAceite> {

  constructor(
    protected injector: Injector
  ) {
    super(`termo-acesso-usuario-aceites`, injector);
  }

  public aceitar(termo: TermoAcessoUsuarioAceite) {
    return this.http.post(
      `${this.api}/aceitar`,
      { termo }
    ).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }
}
